import { API_PDC_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const accountsConstants = {
  GET_RECONCILIATION_ACCOUNTS_START: "GET_RECONCILIATION_ACCOUNTS_START",
  GET_RECONCILIATION_ACCOUNTS_SUCCESS: "GET_RECONCILIATION_ACCOUNTS_SUCCESS",
  GET_RECONCILIATION_ACCOUNTS_ERROR: "GET_RECONCILIATION_ACCOUNTS_ERROR",
  SET_MOVEMENT_LINKED: "SET_MOVEMENT_LINKED"
};

export function loadReconciliationAccounts(
  auth, accountantUuid, companyUuid
) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: accountsConstants.GET_RECONCILIATION_ACCOUNTS_START
      });

      let request = {
        method: "get",
        url: API_PDC_URL_V1 + `/bank/accounts?itemId=${companyUuid}&managerId=${accountantUuid}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false, ["401"]
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: accountsConstants.GET_RECONCILIATION_ACCOUNTS_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: accountsConstants.GET_RECONCILIATION_ACCOUNTS_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: accountsConstants.GET_RECONCILIATION_ACCOUNTS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
